import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import get from 'lodash/get';
import { createSelector } from 'reselect';

//@ts-ignore
import { getAddViewedHintLoadingStatus, getIsWizardEnabled } from '../user/selectors';

import { Hint, HintStore } from './typings';
import { validateXpath } from './utils';

const wizardStateSelector = (storeState: object): HintStore => get(storeState, 'wizard');

export const getConfig = createSelector(wizardStateSelector, (state: HintStore): Array<Hint> | null =>
    get(state, 'config')
);

export const getMatchedHints = createSelector(
    wizardStateSelector,
    (state: HintStore): Array<Hint> => get(state, 'matchedHints')
);

export const getValidHints = createSelector(getMatchedHints, (objHints: Array<Hint>): Array<Hint> => {
    return objHints.filter((hint) => hint && validateXpath(hint.xpath));
});

export const getIsLoading = createSelector(
    getAddViewedHintLoadingStatus,
    (status: LOADING_STATUSES): boolean => status === LOADING_STATUSES.LOADING
);

/**
 * @param {Object} storeState
 * @param {PropsWithIntl} ownProps
 * @return {Boolean}
 */
export const getShouldShowWizard = createSelector([getIsWizardEnabled], (enabled: boolean): boolean => enabled);
